import { type IOrderListItem } from '@/types/IOrder';
import { getOrderSequence } from './getOrderSequence';

export interface IMergedOrders {
  /** Итоговый список для рендера — новые сверху. */
  list: IOrderListItem[];
}

/**
 * «Новые сверху» — по порядковому номеру из хвоста `formated_id`. До PAR-5189
 * сравнивался `id`, которого больше нет ни в выдаче, ни в событии.
 */
export const byNewestFirst = (a: IOrderListItem, b: IOrderListItem): number =>
  getOrderSequence(b) - getOrderSequence(a);

/**
 * Сливает эфемерный realtime-слой (`liveOrders`) с серверным списком (`orders`).
 *
 * Дубли снимаются по `uuid`, приоритет у записи из live-слоя — она свежее.
 * Итог сортируется «новые сверху», то есть новый заказ из сокета встаёт на
 * свою естественную позицию, а не поднимается наверх: если в таблице есть
 * заказы новее, он окажется под ними.
 *
 * Ключ — `uuid`, а не `id` (PAR-5189): на бэкенде без `id` склейка по
 * `undefined` сочла бы дублем каждую строку выдачи, и от страницы остались бы
 * одни заказы из сокета.
 *
 * @param serverOrders - заказы из серверной выдачи
 * @param liveOrders - заказы, пришедшие по сокету (эфемерные)
 * @returns общий список для рендера
 */
export const mergeLiveOrders = (
  serverOrders: IOrderListItem[],
  liveOrders: IOrderListItem[]
): IMergedOrders => {
  const liveUuids = new Set(liveOrders.map((order) => order.uuid));
  const serverWithoutDuplicates = serverOrders.filter(
    (order) => !liveUuids.has(order.uuid)
  );

  return {
    list: [...liveOrders, ...serverWithoutDuplicates].sort(byNewestFirst)
  };
};
